module.exports = __webpack_public_path__ + "static/office_outing_2-5b9eca1adff8ca774829dd66d5eea8bb.jpg";